import get from 'lodash/get';

export default function isPayoutCardFieldDisabled(fieldKey, formData) {
  if (get(formData, 'paymentOption', false)) {
    switch (fieldKey) {
      case 'cardNumber':
        return true;

      default:
        return false;
    }
  }

  return false;
}
